<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-space-between align-center mb-6">
          <h1 class="text-h4 font-weight-bold">Panel de Administración</h1>
          <v-btn color="error" variant="outlined" @click="handleLogout">
            <v-icon start>mdi-logout</v-icon>
            Cerrar Sesión
          </v-btn>
        </div>

        <v-divider class="mb-6"></v-divider>

        <router-view />

      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const route = useRoute()
const router = useRouter()
const store = useStore()
const currentSection = ref('')

const currentUser = computed(() => store.getters.currentUser)

watch(
  () => route.path,
  (newPath) => {
    currentSection.value = newPath
  },
  { immediate: true }
)

const handleLogout = async () => {
  await store.dispatch('logout')
  await router.push('/login')
}
</script>
